/**
* Scrolling CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.scrolling-cta' ).length ) {
        let top = $( '.navbar' ).outerHeight();
        if ( $( '.logged-in' ).length ) {
          top += 32;
        }
        $( '.scrolling-cta' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: $( this ),
              scrub: 1,
              start: `top top+=${top}`,
              end: 'bottom top',
              pin: true,
              // markers: true,
            },
          } );
          tl.to( $( this ), {duration: 4, clipPath: 'circle(100%)'} ),
          tl.fromTo( '.scrolling-cta__content', {opacity: 0, y: 100}, {opacity: 1, y: 0}, '-=2' ),
          tl.fromTo( '.scrolling-cta__link', {scale: 0}, {scale: 1}, '<' );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cta', COMPONENT );
} )( app );
